<template>
    <div>
        <div ref="pieChart" style="width: 100%; height: 400px;"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        chartData: [
            { species: "mouse", count: 248633 },
            { species: "human", count: 289828 },
        ],
        };
    },
    mounted() {
        this.renderChart();
    },
    methods: {
        renderChart() {
        // 使用ECharts绘制饼图
        const pieChart = this.$echarts.init(this.$refs.pieChart);

        const option = {
            tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            series: [
            {
                name: "Enhancer Number",
                type: "pie",
                radius: "80%",
                data: this.chartData.map((item) => ({
                    name: item.species,
                    value: item.count,
                })),
                label: {
                    show: true,
                    formatter: '{b}',
                    textStyle: {
                        fontWeight: 'bold', // 设置字体加粗
                        fontSize: 14,      // 设置字体大小
                    },
                },
                color: ["#9BB0C1", "#51829B"], // 设置饼图颜色
            },
            ],
        };

        pieChart.setOption(option);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Speciesfig.vue